import { axiosAjax } from '@app/src/config/axios';
import { hydrateProcessCip } from './hydrators';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { getSettings } from '@app/src/configuration/config.service';

export const serviceProcessCip = {
  async getData(values: Object, url: string, refreshToken?: string) {
    try {
      let token = refreshToken ? refreshToken : sessionStorage.getItem('accessToken');
      const { data } = await axiosAjax.post(url, values, {
        headers: { Authorization: `Bearer ${token}` }
      })
      return hydrateProcessCip(data);
    } catch(e) {
      throw e.response.data;
    }
  }
}

export const serviceRefreshToken = {
  async getData(refreshToken) {
    try {
      const expToken = sessionStorage.getItem('accessToken');
      const { data, headers } = await axiosAjax.post(getSettings().API_REFRESH_TOKEN, { refreshToken, expToken });
      const refreshtoken = headers.authorization;
      localStorage.setItem('refreshtoken', refreshtoken);
      if(data.code == 100){
        sessionStorage.setItem('accessToken', data.data.accessToken);
        sessionStorage.setItem('reportToken', data.data.reportToken);
        return data;
      }else{
        throw new Error(data.message);
      }
    } catch (e) {
      throw e.response.data;
    }
  }
}
